'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

function () {var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},_ref$id = _ref.id,id = _ref$id === undefined ? 'tooltip' : _ref$id;return _react2.default.createElement('span', { id: id });};module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/EmptyTooltip/EmptyTooltip.js
// module id = 2648
// module chunks = 0